// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-step-input-container {
    position: relative;
}

.settings-step-input-element::-webkit-inner-spin-button,
.settings-step-input-element::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.settings-step-input-buttons-container {
    display: none;
    flex-direction: column;
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translate(0px, -50%);
    height: calc(100% - 4px);
    width: 14px;
    padding: 2px;
    background: var(--theia-input-background);
}

.settings-step-input-buttons-container-perc {
    right: 14px;
}

.settings-step-input-container:hover > .settings-step-input-buttons-container {
    display: flex;
}

.settings-step-input-up-button {
    transform: rotate(-180deg);
}

.settings-step-input-button {
    border: none;
    border-radius: 0;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    cursor: pointer;
    line-height: 12px;
}

.settings-step-input-button:hover {
    background: rgba(128, 128, 128, 0.8);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/settings-step-input.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,+BAA+B;IAC/B,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".settings-step-input-container {\r\n    position: relative;\r\n}\r\n\r\n.settings-step-input-element::-webkit-inner-spin-button,\r\n.settings-step-input-element::-webkit-outer-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\n.settings-step-input-buttons-container {\r\n    display: none;\r\n    flex-direction: column;\r\n    position: absolute;\r\n    right: 0px;\r\n    top: 50%;\r\n    transform: translate(0px, -50%);\r\n    height: calc(100% - 4px);\r\n    width: 14px;\r\n    padding: 2px;\r\n    background: var(--theia-input-background);\r\n}\r\n\r\n.settings-step-input-buttons-container-perc {\r\n    right: 14px;\r\n}\r\n\r\n.settings-step-input-container:hover > .settings-step-input-buttons-container {\r\n    display: flex;\r\n}\r\n\r\n.settings-step-input-up-button {\r\n    transform: rotate(-180deg);\r\n}\r\n\r\n.settings-step-input-button {\r\n    border: none;\r\n    border-radius: 0;\r\n    height: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    user-select: none;\r\n    cursor: pointer;\r\n    line-height: 12px;\r\n}\r\n\r\n.settings-step-input-button:hover {\r\n    background: rgba(128, 128, 128, 0.8);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
